import Raven from 'raven-js';
import { Component } from 'react';
import { buildUrl, parseUrl } from 'hub-http/helpers/url';
import { withRouter } from 'react-router-dom';
import { _getUMSUpgradeKeyFromQueryParams } from './utils/getUMSUpgradeKey';
import { Metrics } from '../utils/metrics';

// props passed in when withErrorBoundary is called

// props that come from passing into withErrorBoundary and those added by
// withRouter
// children comes from withErrorBoundary rendering <WrappedComponent>
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * We don't want to send the full url to history.push so this hacky solution
 * drops the unwanted bits.
 * We need to build better pricing page linking in SSAPI to replace this.
 */
const trimPricingPageURL = href => {
  const pieces = parseUrl(href);
  const withoutPricingAndPortalId = pieces.path.split('/').slice(3).join('');

  // drops off the https://www.app.hubspotqa.com/pricing/{portalId}
  return buildUrl({
    path: withoutPricingAndPortalId,
    query: pieces.query
  });
};
export class ErrorBoundary extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      hasError: false
    };
    this.source = _getUMSUpgradeKeyFromQueryParams();
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(error) {
    Metrics.counter('error-boundary', {
      boundary_name: this.props.boundaryName
    });
    Raven.captureException(error, {
      extra: {
        message: 'Error boundary caught uncaught exception',
        boundaryName: this.props.boundaryName,
        source: this.source
      }
    });
  }
  render() {
    if (this.state.hasError) {
      const {
        boundaryName,
        redirectCallback,
        history
      } = this.props;
      console.error('ErrorBoundary caught uncaught error', boundaryName, this.source);
      if (redirectCallback) {
        console.warn('redirecting', boundaryName, this.source);
        history.push(trimPricingPageURL(redirectCallback(this.source)));
      }
      return null;
    }
    return this.props.children;
  }
}
export function withErrorBoundary(WrappedComponent, errorBoundaryProps) {
  const ErrorBoundaryWrapper = props => /*#__PURE__*/_jsx(ErrorBoundary, Object.assign({}, errorBoundaryProps, {
    history: props.history,
    location: props.location,
    match: props.match,
    children: /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props))
  }));
  return withRouter(ErrorBoundaryWrapper);
}